export const sustainabilityPage = {
  audio: {
    bgMusic: 'Arka plan müziği',
    mainTitle: 'Sürdürülebilirlik · Topraklama · Organik Yaşam',
  },
  materialsSection: {
    label: 'Malzemelerimiz',
    title: 'Doğadan Gelen, Doğaya Dönen',
    subtitle: 'Her malzeme, gezegenimize ve sağlığınıza duyduğumuz saygının somut kanıtıdır.',
    allLabel: 'Tüm Sürdürülebilir Malzemelerimiz',
    allSubtitle: 'Her biri doğadan ilham alan, doğaya saygılı seçimler',
    target: 'Hedefimiz',
  },
  manifesto: {
    label: 'Manifestomuz',
    title: 'Neden Varız?',
    p1: 'Moda endüstrisi, dünya genelinde ikinci en büyük su tüketicisi ve en büyük kimyasal kirleticilerden biridir. Her yıl 92 milyon ton tekstil atığı üretilmekte, bu atıkların büyük çoğunluğu çöplüklerde yüzyıllarca bozunmadan kalmaktadır.',
    p2: 'FentyBarefoot olarak bu tabloya karşı durmak için kurulduk. Organic fashion anlayışımız; sadece organik malzeme kullanmaktan ibaret değil — üretimden ambalaja, lojistikten ürün ömrüne kadar her adımda çevresel ve sosyal sorumluluğu esas almak demektir.',
    p3: 'Anadolu\'nun binlerce yıllık el sanatları geleneğini, modern sürdürülebilirlik bilimiyle buluşturuyoruz. Bitkisel boyalarla renklendirilen, bitkisel tanenlerle işlenen ve usta ellerin dokunuşuyla hayat bulan her ürünümüz; hem gezegenimize hem de onu taşıyan insanlara saygının somut ifadesidir.',
    zeroBadge: '2024 itibarıyla %100 Karbon Nötr',
    carbonLabel: 'Karbon Ayak İzi',
    carbonVal: 'Sıfır Emisyon',
  },
  organicCotton: {
    label: 'Organik Pamuk Elbiseler',
    title: 'Cildinizdeki Her Dokunuş',
    titleHighlight: 'Doğadan Geliyor',
    p1: 'Organik pamuk elbiselerimiz, Ege ve Çukurova\'nın GOTS sertifikalı çiftliklerinden temin edilen ipliklerle dokunmaktadır. Geleneksel tezgahlarda dokunan kumaşlar, bitkisel boyalarla renklendirilerek el dikişiyle biçimlendirilir.',
    p2: 'Neden organik pamuk? Geleneksel pamuk üretimi, dünya genelinde kullanılan tarım ilaçlarının %16\'sını tüketir. Organik pamuk ise bu kimyasalların tamamından arındırılmış, toprağı besleyen ve biyoçeşitliliği koruyan bir üretim sürecinden geçer.',
    p3: 'Elbiselerimizin her dikişi, Anadolu\'nun köklü terzilik geleneğini yaşatan ustalar tarafından atılmaktadır. Makine dikişinin yerini alan el dikişi; hem daha dayanıklı hem de onarılabilir bir ürün ortaya çıkarır.',
    f1: '%91 Daha Az Su',
    f2: 'Sıfır Pestisit',
    f3: 'Hipoalerjenik',
    f4: 'Biyobozunur',
  },
  veganLeather: {
    label: 'Vegan & Bitkisel Deri',
    title: 'Kimyasal İçermeyen Deri',
    titleHighlight: 'Mümkün mü? Evet.',
    subtitle: 'Geleneksel deri endüstrisinin kimyasal yükünü sıfıra indiren iki devrimci yaklaşım: bitkisel tabaklamanın kadim bilgeliği ve yeni nesil biyomalzemelerin gücü.',
    card1Label: 'Bitkisel Tabaklamanın Sırrı',
    card1Text: 'Meşe palamudu, kestane kabuğu ve mimoza çiçeğinden elde edilen doğal tanenler, deriyi yavaş ve özenli bir süreçte işler. Bu yöntem 3.000 yıllık bir gelenektir ve krom tabaklamaya kıyasla çevreye sıfıra yakın kimyasal atık bırakır. Bitkisel tabaklamayla işlenen deri; zamanla güzel bir patina kazanır, nefes alır ve onlarca yıl dayanır.',
    card2Label: 'Kaktüs Derisi: Çölden Gelen Devrim',
    card2Text: 'Meksika\'nın Zacatecas eyaletinde yetişen Nopal kaktüsünün yapraklarından üretilen Desserto® derisi; sulama gerektirmez, gübre kullanılmaz ve hasat edilen yapraklar kaktüsün kendisine zarar vermeden toplanır. Üretim sürecinde güneş enerjisi kullanılır.',
    card3Label: 'Mantar Derisi: Ormanın Armağanı',
    card3Text: 'Mylo™ mantar derisi, orman atıklarından beslenen mantar miselinden üretilir. Karbon negatif bir üretim döngüsüne sahip olan bu malzeme; geleneksel derinin dokusunu ve esnekliğini taklit ederken tamamen biyobozunurdur.',
  },
  botanicalDyes: {
    label: 'Bitkisel Boyalar',
    title: 'Renk, Doğanın',
    titleHighlight: 'Kendi Paleti',
    p1: 'Sentetik boyalar, dünya genelinde su kirliliğinin %20\'sinden sorumludur. Boyama atıklarında bulunan ağır metaller ve toksik kimyasallar, nehirlere ve yeraltı sularına karışarak ekosistemi tahrip eder.',
    p2: 'FentyBarefoot\'ta kullandığımız bitkisel boyalar; indigo bitkisi, zerdeçal kökü, nar kabuğu, soğan zarı, kızılcık, çivit otu ve sumak gibi tamamen doğal kaynaklardan elde edilmektedir. Her boya banyosu, bir botanik bahçesinin özünü kumaşa aktarır.',
    p3: 'Bitkisel boyama, her ürüne eşsiz ve tekrar edilemez bir renk tonu kazandırır. Aynı boya banyosundan çıkan iki ürün bile birbirinden hafifçe farklıdır.',
    plant1: 'İndigo Bitkisi',
    plant1Color: 'Derin Mavi & İndigo',
    plant2: 'Zerdeçal Kökü',
    plant2Color: 'Altın Sarısı & Hardal',
    plant3: 'Nar Kabuğu',
    plant3Color: 'Terrakota & Turuncu',
    plant4: 'Kızılcık',
    plant4Color: 'Bordo & Kiremit',
  },
  handcraft: {
    label: 'El İşçiliği & Sanat',
    title: 'Her Dikiş Bir Hikaye,',
    titleHighlight: 'Her Ürün Bir Sanat Eseri',
    subtitle: 'Anadolu\'nun binlerce yıllık el sanatları geleneğini, modern sürdürülebilirlik bilimiyle buluşturuyoruz.',
    step1Title: 'Malzeme Seçimi',
    step1Desc: 'Her deri parçası, her pamuk ipliği tek tek incelenerek seçilir. Kusurlu malzeme kullanılmaz.',
    step2Title: 'Kalıp & Kesim',
    step2Desc: 'Geleneksel ahşap kalıplar kullanılarak elle kesilen parçalar, sıfır fire hedefiyle biçimlendirilir.',
    step3Title: 'El Dikişi',
    step3Desc: 'Saddle stitch tekniğiyle atılan el dikişleri, makine dikişinden 3 kat daha dayanıklıdır.',
    step4Title: 'Son İşlem & Kalite',
    step4Desc: 'Her ürün, ustanın son onayından geçer. Onarılabilirlik için özel dikkat gösterilir.',
    quoteText: 'Bir çift ayakkabı yaparken, o ayakkabıyı giyecek insanın her adımını düşünürüm. Her dikiş, o adımın güvenli ve rahat olması için atılır.',
    quoteAuthor: 'Mehmet Usta',
    quoteRole: '42 Yıllık Deri Ustası · İzmir',
  },
  certsSection: {
    label: 'Sertifikalar & Standartlar',
    title: 'Güvenilirliğimizin Kanıtı',
    subtitle: 'Sürdürülebilirlik iddialarımız boş söz değil — uluslararası bağımsız kuruluşlar tarafından denetlenen ve sertifikalandırılan standartlara dayanmaktadır.',
  },
  timelineSection: {
    label: 'Sürdürülebilirlik Yolculuğumuz',
    title: 'Her Yıl Daha İyiye',
  },
  faqSection: {
    label: 'Sıkça Sorulan Sorular',
    title: 'Merak Ettikleriniz',
  },
  cta: {
    title: 'Sürdürülebilir Moda\nBir Seçim Meselesi',
    subtitle: 'Her satın alma kararınız, gezegenimizin geleceğini şekillendirir. Organik, bitkisel ve el yapımı ürünlerimizle hem stilinizi hem de değerlerinizi yansıtın.',
    cta1: 'Organik Koleksiyonu Keşfet',
    cta2: "Blog'u Oku",
  },
  materials: [
    {
      title: 'Organik Pamuk',
      subtitle: 'GOTS Sertifikalı · Kimyasal İçermez',
      desc: 'Organik pamuk, geleneksel pamuk üretimiyle kıyasla %91 daha az su tüketir ve hiçbir sentetik pestisit ya da gübre kullanılmadan yetiştirilir. FentyBarefoot\'ta kullandığımız her pamuk ipliği, GOTS sertifikasına sahip çiftliklerden temin edilmektedir. Cilde doğrudan temas eden ürünlerimizde tercih ettiğimiz bu malzeme; nefes alabilir yapısı, hipoalerjenik özellikleri ve uzun ömürlülüğüyle öne çıkar.',
      tags: ['GOTS Sertifikalı', 'Pestisitsiz', 'Hipoalerjenik', 'Nefes Alabilir'],
      statLabel: 'Daha Az Su',
    },
    {
      title: 'Bitkisel Deri',
      subtitle: 'Doğal Tanenlerle İşlenmiş · Kimyasalsız',
      desc: 'Bitkisel tabaklamada meşe palamudu, mimoza kabuğu, kestane ve sumak gibi bitkilerin doğal tanenleri kullanılır. Bu geleneksel yöntem, krom tabaklamaya kıyasla çevreye sıfıra yakın kimyasal atık bırakır. Zamanla güzel bir patina kazanan bu deri; nefes alabilir yapısı, dayanıklılığı ve doğal kokusuyla sentetik alternatiflerin çok ötesinde bir deneyim sunar.',
      tags: ['Bitkisel Tanen', 'Krom İçermez', 'Patina Kazanır', 'Uzun Ömürlü'],
      statLabel: 'Kimyasal Atık',
    },
    {
      title: 'Vegan Deri',
      subtitle: 'Kaktüs · Mantar · Ananas Lifi',
      desc: 'Vegan deri artık plastik esaslı PU\'dan ibaret değil. FentyBarefoot, kaktüs yaprağından elde edilen Desserto®, mantar miselinden üretilen Mylo™ ve ananas lifinden yapılan Piñatex® gibi yeni nesil biyomalzemeleri koleksiyonlarına entegre etmektedir.',
      tags: ['Kaktüs Derisi', 'Mantar Derisi', 'Piñatex®', 'Hayvan Dostu'],
      statLabel: 'Hayvan Dostu',
    },
    {
      title: 'Bitkisel Boyalar',
      subtitle: 'İndigo · Zerdeçal · Çivit · Kök Boyası',
      desc: 'Sentetik boyalar, dünya genelinde su kirliliğinin %20\'sinden sorumludur. FentyBarefoot\'ta kullandığımız bitkisel boyalar; indigo bitkisi, zerdeçal kökü, nar kabuğu ve kızılcık gibi tamamen doğal kaynaklardan elde edilmektedir. Bu boyama süreci, her ürüne eşsiz ve tekrar edilemez bir renk tonu kazandırır.',
      tags: ['İndigo Boyası', 'Zerdeçal', 'Nar Kabuğu', 'Sıfır Kimyasal'],
      statLabel: 'Daha Az Kirlilik',
    },
    {
      title: 'El İşçiliği & Sanat',
      subtitle: 'Geleneksel Zanaatkarlık · Sıfır Seri Üretim',
      desc: 'FentyBarefoot\'un her ürünü, Anadolu\'nun köklü el sanatları geleneğini yaşatan ustalar tarafından üretilmektedir. El dikişi; her ürüne benzersiz bir karakter katar ve onarılabilirlik sağlar. El işçiliği, seri üretimin aksine sıfır fire hedefiyle çalışır.',
      tags: ['El Dikişi', 'Anadolu Ustası', 'Onarılabilir', 'Sıfır Fire'],
      statLabel: 'El Yapımı',
    },
  ],
  certifications: [
    { title: 'GOTS Sertifikası', desc: 'Global Organic Textile Standard — organik tekstil üretiminin en yüksek uluslararası standardı.' },
    { title: 'OEKO-TEX® Standard 100', desc: 'Her ürün bileşeni zararlı maddeler açısından test edilmiş ve sertifikalandırılmıştır.' },
    { title: 'B Corp Onaylı', desc: 'Sosyal ve çevresel performans, hesap verebilirlik ve şeffaflık standartlarını karşılıyoruz.' },
    { title: 'Carbon Neutral', desc: '2023 yılından itibaren tüm üretim ve lojistik süreçlerimizde karbon nötr statüsüne ulaştık.' },
    { title: 'Cruelty Free', desc: 'Hiçbir ürünümüzde hayvan testi yapılmaz; vegan ve bitkisel alternatifleri ön planda tutarız.' },
    { title: 'Fair Trade Üretim', desc: 'Tüm üretim ortaklarımız adil ücret, güvenli çalışma koşulları ve etik iş standartlarına uymaktadır.' },
  ],
  timeline: [
    { year: '2018', title: 'Organik Pamuk Geçişi', desc: 'Tüm pamuklu ürünlerde GOTS sertifikalı organik pamuğa geçiş tamamlandı.' },
    { year: '2019', title: 'Bitkisel Tabaklamaya Dönüş', desc: 'Krom tabaklamanın tamamen bırakılması ve geleneksel bitkisel tanen yöntemine dönüş.' },
    { year: '2020', title: 'Vegan Koleksiyon Lansmanı', desc: 'Kaktüs ve mantar derisi kullanılan ilk vegan koleksiyon piyasaya sürüldü.' },
    { year: '2021', title: 'Sıfır Atık Ambalaj', desc: 'Tüm ambalajlar geri dönüştürülmüş kağıt ve biyobozunur malzemelere dönüştürüldü.' },
    { year: '2022', title: 'Güneş Enerjisi Atölyesi', desc: 'Üretim atölyelerimiz %100 yenilenebilir güneş enerjisiyle çalışmaya başladı.' },
    { year: '2023', title: 'Karbon Nötr Statüsü', desc: 'Tüm tedarik zinciri ve lojistik operasyonlarında karbon nötr statüsüne ulaşıldı.' },
    { year: '2024', title: 'El İşçiliği Akademisi', desc: 'Anadolu\'nun geleneksel deri ustalarını geleceğe taşıyacak zanaatkarlık akademisi kuruldu.' },
  ],
  faqs: [
    {
      q: 'Bitkisel deri ile normal deri arasındaki fark nedir?',
      a: 'Bitkisel deri, meşe palamudu, kestane kabuğu ve mimoza çiçeğinden elde edilen doğal tanenlerle işlenir. Bu yöntem 3.000 yıllık bir gelenektir. Bitkisel tabaklamayla işlenen deri; zamanla güzel bir patina kazanır, nefes alır ve onlarca yıl dayanır.',
    },
    {
      q: 'Vegan deri gerçek deriden daha mı dayanıklı?',
      a: 'Kaktüs ve mantar bazlı yeni nesil vegan deriler, dayanıklılık açısından geleneksel deriyle yarışabilir düzeydedir. Tüm vegan deri ürünlerimiz 2 yıl garanti kapsamındadır.',
    },
    {
      q: 'Bitkisel boyalı ürünler solmaz mı?',
      a: 'Bitkisel boyalar, sentetik boyalar gibi solmaz; aksine zamanla daha derin ve zengin tonlar kazanır. Doğru bakımla bitkisel boyalı ürünler onlarca yıl güzelliğini korur.',
    },
    {
      q: 'El yapımı ürünler seri üretimden neden daha değerlidir?',
      a: 'El yapımı üretimde her parça bireysel olarak işlenir; bu da sıfır fire ve maksimum kalite kontrolü anlamına gelir. El yapımı ürünler onarılabilir olduğundan ömürleri seri üretim ürünlerin 3-5 katına çıkabilir.',
    },
    {
      q: 'Organik pamuk neden daha pahalıdır?',
      a: 'Organik pamuk, sertifikasyon süreçleri, daha düşük verim ve el emeği yoğun hasat yöntemleri nedeniyle daha yüksek maliyete sahiptir. Ancak uzun vadede cilt sağlığına katkısı ve ürün ömrünün uzunluğu göz önüne alındığında gerçek değeri çok daha yüksektir.',
    },
  ],
  noWar: {
    badge: 'Barış İçin Duruş',
    title: 'Savaşa Hayır,\nYaşama Evet',
    subtitle: 'Hiçbir insan ölümünü desteklemiyoruz. Kimyasal silahlara, doğanın dengesini bozan her eyleme ve tüm canlılara zarar veren her şeye karşıyız.',
    p1: 'Sürdürülebilirlik sadece malzeme seçiminden ibaret değildir. Gerçek sürdürülebilirlik; insanın insana, insanın doğaya verdiği her türlü zarara karşı durmayı gerektirir. Bu nedenle savaşa, şiddet ve kimyasal silahlara açıkça karşı olduğumuzu ilan ediyoruz.',
    p2: 'Kimyasal silahlar; toprağı, suyu ve havayı kirletir. Nesiller boyu süren hastalıklara, toprak çoraklaşmasına ve biyoçeşitlilik kaybına yol açar. Atmosferi bozan, dünya dengesini tahrip eden, canlıların yaşam hakkını elinden alan bu araçlara karşı olmak; gezegenimize duyduğumuz saygının ayrılmaz bir parçasıdır.',
    p3: 'Dünyanın dengesi; barış içinde yaşayan insanların, korunan doğanın ve sürdürülebilir üretimin bir aradası olmasını gerektirir. FentyBarefoot olarak her ürünümüzde bu inancı taşıyor, gelecek nesillere barışçıl ve yeşil bir dünya bırakmak için çalışıyoruz.',
    stat1: 'Savaş Karşıtıyız',
    stat2: 'Kimyasal Silahlara Karşıyız',
    stat3: 'Doğayı Koruyoruz',
    stat4: 'Yaşamı Savunuyoruz',
    quoteText: 'Barış olmadan sürdürülebilirlik olmaz. İnsanlığa ve doğaya zarar veren her şeye karşı durmak, hem etik hem de ekolojik bir sorumluluktur.',
  },
};
